import { Grid } from "@material-ui/core";
import React from "react";
import { Text, Input, Button, TextArea, SelectBox } from "sunrise-ui";
import Checkbox from "@material-ui/core/Checkbox";

//---for api-------------
import { useDispatch, useSelector } from "react-redux";
import { getStpesData } from "../../redux/reducers";
import { AppDispatch } from "../../redux/store";
import {
  postCreateProjectData,
  getAllProjectData,
  putProjectData,
  getProjectTypeData,
} from "../../redux/reducers/projectReducers";
import { postPdf } from "../../redux/reducers/pdf";

// ------for table--------------
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import { uiSliceActions } from "../../redux/reducers/uiState";

import WorkOrderItems from "./WorkOrderItems";
import Loader from "../../utilities/Loader";
import toaster from "../../utilities/toaster";

//------validiator---------
const validaiator = (state: any, action: any) => {
  switch (action.type) {
    case "projectName":
      return { ...state, projectName: action.payload, projectNameErr: false };
    case "projectCity":
      return { ...state, projectCity: action.payload, projectCityErr: false };
    case "mainContractorName":
      return {
        ...state,
        mainContractorName: action.payload,
        mainContractorNameErr: false,
      };
    case "clientName":
      return { ...state, clientName: action.payload, clientNameErr: false };
    case "typeOfProject":
      return {
        ...state,
        typeOfProject: action.payload,
        typeOfProjectErr: false,
      };
    case "description":
      return { ...state, description: action.payload };
    case "projectStartDate":
      return {
        ...state,
        projectStartDate: action.payload,
        projectCompleteDate: "",
        projectStartDateErr: false,
      };
    case "projectCompleteDate":
      return {
        ...state,
        projectCompleteDate: action.payload,
        projectCompleteDateErr: false,
      };
    case "workOrderIssueDate":
      return {
        ...state,
        workOrderIssueDate: action.payload,
        workOrderIssueDateErr: false,
      };
    case "workOrderValue":
      return {
        ...state,
        workOrderValue: action.payload,
        workOrderValueErr: false,
      };
    case "totalPileLength":
      return {
        ...state,
        totalPileLength: action.payload,
        totalPileLengthErr: false,
      };
    case "projectNameErr":
      return { ...state, projectNameErr: action.payload };
    case "projectCityErr":
      return { ...state, projectCityErr: action.payload };
    case "mainContractorNameErr":
      return { ...state, mainContractorNameErr: action.payload };
    case "clientNameErr":
      return { ...state, clientNameErr: action.payload };
    case "typeOfProjectErr":
      return { ...state, typeOfProjectErr: action.payload };
    case "projectStartDateErr":
      return { ...state, projectStartDateErr: action.payload };
    case "projectCompleteDateErr":
      return { ...state, projectCompleteDateErr: action.payload };
    case "workOrderIssueDateErr":
      return { ...state, workOrderIssueDateErr: action.payload };
    case "workOrderValueErr":
      return { ...state, workOrderValueErr: action.payload };
    case "totalPileLengthErr":
      return { ...state, totalPileLengthErr: action.payload };
    case "reset":
      return { ...initialProjectIfoState };
    default:
      return { ...state, workOrderValue: action.payload };
  }
};

const useStylesForTable = makeStyles({
  table: {
    minWidth: 650,
  },
});

const initialProjectIfoState = {
  projectName: "",
  projectNameErr: false,
  projectCity: "",
  projectCityErr: false,
  mainContractorName: "",
  mainContractorNameErr: false,
  clientName: "",
  clientNameErr: false,
  typeOfProject: "",
  typeOfProjectErr: false,
  description: "",
  projectStartDate: "",
  projectStartDateErr: false,
  projectCompleteDate: "",
  projectCompleteDateErr: false,
  workOrderIssueDate: "",
  workOrderIssueDateErr: false,
  workOrderValue: "",
  workOrderValueErr: false,
  totalPileLength: "",
  totalPileLengthErr: false,
};

const CreateProject = () => {
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);
  let [loadingBtn, setLoadingBtn] = React.useState(false);
  let [isLandedNow, setIsLandedNow] = React.useState(false);
  const [totalPoints, setTotalPoints] = React.useState(0);
  const [totalPointsErr, setTotalPointsErr] = React.useState(false);
  // ----------to get the step names of pile filling---------
  const dispatch = useDispatch<AppDispatch>();
  const dispatchEditProject = useDispatch<AppDispatch>();
  //-----to get pile filling steps and project types ------
  React.useEffect(() => {
    setLoading(true);
    !stepsData &&
      dispatch(
        getStpesData({ endPoint: "master-data/get-master-data?type=piles" })
      );
    !projectTypes &&
      dispatch(
        getProjectTypeData({
          endPoint: "master-data/get-master-data?type=project-type",
        })
      );
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const projectTypes = useSelector(
    (state: any) => state.PROJECT.projectTypeData
  );
  const stepsData = useSelector((state: any) => state.UI.stepsData);
  const createProjectData = useSelector(
    (state: any) => state.PROJECT.createProjectData
  );
  const updateProjectData = useSelector(
    (state: any) => state.PROJECT.updateProjectData
  );
  const editData = useSelector((state: any) => state.SPECIFICPROJECT.first);
  const workOrderItemData: any = useSelector(
    (state: any) => state.SPECIFICPROJECT.workOrderItemState
  );

  // -----------for passbook image upload--------
  const [pdfName, setPdfName] = React.useState("");
  const [pdfErr, setPdfErr] = React.useState(false);
  const pdfFileInputRef = React.useRef<HTMLInputElement>(null);

  //--- pile filling steps table style----
  const tableClasses = useStylesForTable();

  //--------for pile Filling step slection form--------
  const initialStepsTemplate =
    stepsData &&
    stepsData?.map((value: any) => ({
      checkbox: false,
      stepNumber: "",
      nameOfStep: value,
      idealTime: "",
      weightageStart: "",
      weightageComplete: "",
      isMandatory: "mandatory",
    }));
  const [stepsValues, setStepValues] = React.useState([
    ...initialStepsTemplate,
  ]);

  const initialStepsErrorTemplate =
    stepsData &&
    stepsData?.map((value: any) => ({
      stepNumberErr: false,
      idealTimeErr: false,
      weightageStartErr: false,
      weightageCompleteErr: false,
    }));
  const [stepsValuesError, setStepValuesError] = React.useState([
    ...initialStepsErrorTemplate,
  ]);

  React.useEffect(() => {
    var temp = 0;
    for (let i = 0; i <= stepsValues.length - 1; i++) {
      temp += +stepsValues[i]["weightageStart"];
      temp += +stepsValues[i]["weightageComplete"];
    }
    setTotalPoints(temp);
    setTotalPointsErr(false);
  }, [stepsValues]);

  React.useEffect(() => {
    if (stepsValues.length === 0) {
      setStepValues([...initialStepsTemplate]);
      setStepValuesError([...initialStepsErrorTemplate]);
    }
    return;
  }, [
    stepsData,
    dispatch,
    stepsValues.length,
    initialStepsTemplate,
    initialStepsErrorTemplate,
  ]);

  const handleStepChange = (i: number, e: any) => {
    const event = { ...e };
    let newItems: any[] = [...stepsValues];
    if (event.target.name === "checkbox") {
      newItems[i][event.target.name] = event.target.checked;
      setCheckboxCountErr(false);
      if (event.target.checked === false) {
        newItems[i]["stepNumber"] = "";
        newItems[i]["idealTime"] = "";
        newItems[i]["weightageStart"] = "";
        newItems[i]["weightageComplete"] = "";
        stepsValuesError[i]["stepNumberErr"] = false;
        stepsValuesError[i]["idealTimeErr"] = false;
        stepsValuesError[i]["weightageStartErr"] = false;
        stepsValuesError[i]["weightageCompleteErr"] = false;
      }
    } else if (event.target.name === "weightageStart") {
      newItems[i][event.target.name] = event.target.value;
      // newItems[i]["weightageComplete"] = // 100 -
      // Number(event.target.value).toString();
      stepsValuesError[i]["weightageCompleteErr"] = false;
      // setTotalPoints(totalPoints + +event.target.value);
    } else if (event.target.name === "weightageComplete") {
      newItems[i][event.target.name] = event.target.value;
      // newItems[i]["weightageStart"] = // 100 -
      // Number(event.target.value).toString();
      stepsValuesError[i]["weightageStartErr"] = false;
      // setTotalPoints(totalPoints + +event.target.value);
    } else if (event.target.name === "stepNumber") {
      newItems[i][event.target.name] = event.target.value;
      setDupStepNumberErr(false);
    } else {
      newItems[i][event.target.name] = event.target.value;
    }
    stepsValuesError[i][`${event.target.name}Err`] = false;

    setStepValues(newItems);
  };
  const [state, dispatchState] = React.useReducer(
    validaiator,
    initialProjectIfoState
  );

  //----checkbox count and duplicate step number error state
  const [checkboxCountErr, setCheckboxCountErr] = React.useState(false);
  const [dupStepNumberErr, setDupStepNumberErr] = React.useState(false);

  //---------handle submit to add a project---
  const handleSubmit = () => {
    if (loadingBtn === false) {
      let goodToGo = true;
      for (const [key, value] of Object.entries(state)) {
        if (key !== "description" && value === "") {
          dispatchState({ type: `${key}Err`, payload: true });
          goodToGo = false;
        } else {
          goodToGo = true;
        }
      }

      if (pdfName === "") {
        setPdfErr(true);
        goodToGo = false;
      }
      console.log("TotalPoints remaining", 100 - totalPoints);

      if (100 - totalPoints !== 0) {
        setTotalPointsErr(true);
        goodToGo = false;
      }
      let checkBoxCheckedCount = 0;
      stepsValues?.forEach((item: any, index: number) => {
        if (item.checkbox === true) {
          checkBoxCheckedCount = checkBoxCheckedCount + 1;
          let newItems: any[] = [...stepsValuesError];
          for (const [key, value] of Object.entries(item)) {
            if (value === "") {
              newItems[index][`${key}Err`] = true;
              goodToGo = false;
            } else if (key === "idealTime") {
              let val: any = value;
              if (!/^\d{0,3}(\.(25|50|75|5|00|0))?$/.test(val)) {
                toaster(
                  "error",
                  "Decimal places of ideal time should be .25 , .50 or .75"
                );
                goodToGo = false;
              }
            } else {
              newItems[index][`${key}Err`] = false;
            }
          }
          setStepValuesError(newItems);
        }
      });
      if (checkBoxCheckedCount < 4) {
        setCheckboxCountErr(true);
        goodToGo = false;
      }
      let valueArr: any[] = [];
      stepsValues?.forEach((item) => {
        if (item.stepNumber !== "") {
          valueArr.push(item.stepNumber.toString());
        }
      });
      let seen = valueArr.filter(
        (
          (s) => (v) =>
            s.has(v) || !s.add(v)
        )(new Set())
      );

      if (seen?.length > 0) {
        setDupStepNumberErr(true);
        goodToGo = false;
      }
      //--check workorder Item---
      setTriggered(true);
      if (goodToGo === true) {
        // --------Api call to add project------

        const pileInformationArray: any = [];
        stepsValues?.forEach((item: any, index: number) => {
          if (item.checkbox === true) {
            let obj = {
              stepNumber: stepsValues[index].stepNumber,
              stepName: stepsValues[index].nameOfStep,
              idealCompletionTime: Number(stepsValues[index].idealTime),
              weightageOfStartingPoint: Number(
                stepsValues[index].weightageStart
              ),
              weightageOfEndingPoint: Number(
                stepsValues[index].weightageComplete
              ),
              isMandatory:
                stepsValues[index].isMandatory === "mandatory" ? true : false,
            };
            pileInformationArray.push(obj);
          }
        });
        const myObj = {
          projectName: state.projectName,
          projectCity: state.projectCity,
          mainContractor: state.mainContractorName,
          clientInfo: state.clientName,
          type: state.typeOfProject.toLowerCase(),
          description: state.description,
          startDate: new Date(state.projectStartDate).toISOString(),
          expectedEndDate: new Date(state.projectCompleteDate).toISOString(),
          workOrderInformation: {
            issuedDate: new Date(state.workOrderIssueDate).toISOString(),
            totalPileLength: Number(state.totalPileLength).toFixed(2),
            workOrderValue: Number(state.workOrderValue).toFixed(2),
            workOrderDoc: pdfName,
            workOrderItemDetails: workOrderItemData,
          },
          pileInformation: [...pileInformationArray],
        };

        if (editData?.type === "edit") {
          setLoadingBtn(true);
          dispatchEditProject(
            putProjectData({
              endPoint: `project/update-project/${editData?.projectID}`,
              data: myObj,
            })
          ).then(() => {
            setLoadingBtn(false);
          });
        } else {
          setLoadingBtn(true);
          dispatch(
            postCreateProjectData({
              endPoint: "project/create-project",
              data: myObj,
            })
          ).then(() => {
            setLoadingBtn(false);
          });
        }
      }
    }
  };
  React.useEffect(() => {
    if (createProjectData?.status || updateProjectData?.status) {
      dispatch(getAllProjectData({ endPoint: "project/get-all-projects" }));
      handleCancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createProjectData, updateProjectData]);
  const handleCancel = () => {
    setStepValues([...initialStepsTemplate]);
    setPdfName("");
    dispatchState({ type: "reset", payload: "" });
    setEditButton(false);
    dispatch(uiSliceActions.setInitial());
    dispatch(uiSliceActions.setWorkOrderItemInitialState());
    dispatch(uiSliceActions.setInitalIsworkItem());
    setWoCancel(true);
  };
  //----for project edit---
  const [editButton, setEditButton] = React.useState(false);

  React.useEffect(() => {
    setIsLandedNow(true);
    if (editData?.type === "edit" && isLandedNow) {
      setCheckboxCountErr(false);
      setPdfErr(false);
      setEditButton(true);
      dispatchState({
        type: "projectName",
        payload: editData?.projectDetail?.projectName,
      });
      dispatchState({
        type: "projectCity",
        payload: editData?.projectDetail?.projectCity,
      });
      dispatchState({
        type: "mainContractorName",
        payload: editData?.projectDetail?.mainContractor,
      });
      dispatchState({
        type: "clientName",
        payload: editData?.projectDetail?.clientInfo,
      });
      dispatchState({
        type: "typeOfProject",
        payload: editData?.projectDetail?.type,
      });
      dispatchState({
        type: "description",
        payload: editData?.projectDetail?.description,
      });
      dispatchState({
        type: "workOrderIssueDate",
        payload:
          editData?.projectDetail?.workOrderInformation?.issuedDate?.split(
            "T"
          )[0],
      });

      dispatchState({
        type: "projectStartDate",
        payload: editData?.projectDetail?.startDate.split("T")[0],
      });
      dispatchState({
        type: "projectCompleteDate",
        payload: editData?.projectDetail?.expectedEndDate.split("T")[0],
      });
      dispatchState({
        type: "workOrderValue",
        payload: editData?.projectDetail?.workOrderInformation?.workOrderValue,
      });
      dispatchState({
        type: "totalPileLength",
        payload: editData?.projectDetail?.workOrderInformation?.totalPileLength,
      });
      setPdfName(editData?.projectDetail?.workOrderInformation?.workOrderDoc);
      editData?.projectDetail?.pileInformation.forEach(
        (item: any, index: number) => {
          let newItems: any[] = [...stepsValues];
          newItems?.forEach((data: any, i: number) => {
            if (item.stepName === data.nameOfStep) {
              newItems[i]["checkbox"] = true;
              newItems[i]["stepNumber"] = item.stepNumber;
              newItems[i]["idealTime"] = item.idealCompletionTime;
              newItems[i]["weightageStart"] = item.weightageOfStartingPoint;
              newItems[i]["weightageComplete"] = item.weightageOfEndingPoint;
              newItems[i]["isMandatory"] =
                item.isMandatory === true ? "mandatory" : "optional";
            }
          });

          setStepValues(newItems);
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData]);
  const changeReset = () => {};
  //---for step number selectbox data----
  const [stepNumbers, setStepNumbers] = React.useState([""]);
  React.useEffect(() => {
    let itemCount = 0;
    let getStepNumbers = [];
    stepsValues.forEach((item: any, key: number) => {
      if (item.checkbox === true) {
        itemCount = itemCount + 1;
      }
    });
    for (var i = 0; i < itemCount; i++) {
      getStepNumbers.push((i + 1).toString());
    }
    setStepNumbers(getStepNumbers);
  }, [stepsValues]);

  //---to reset project type--
  const changeResetProjectType = () => {};
  //--- to check work order item-----
  const [triggered, setTriggered] = React.useState(false);
  const [woCancel, setWoCancel] = React.useState(false);
  const changeBackToFalse = () => {
    setTriggered(false);
  };
  // ---to get work order valye and pile length from work order item page---
  let initialWorkOrderItems = {
    name: "",
    quantity: "",
    unit: "",
    rate: "",
    basicAmount: "",
  };
  let [workOrderItems, setWorkOrderItems] = React.useState([
    initialWorkOrderItems,
  ]);

  React.useEffect(() => {
    // let pileLength =
    //   Number(workOrderItems[0]?.rate) * Number(workOrderItems[0]?.quantity);
    let pileLength = 0;
    let totalWoValue = 0;
    workOrderItems?.forEach((item) => {
      totalWoValue =
        totalWoValue + Number(item?.basicAmount === "" ? 0 : item?.basicAmount);
      pileLength =
        pileLength +
        Number(
          item?.name.slice(0, 6).toLowerCase() === "boring" ? item?.quantity : 0
        );
    });
    dispatchState({
      type: "workOrderValue",
      payload: totalWoValue,
    });
    dispatchState({
      type: "totalPileLength",
      payload: pileLength,
    });
  }, [workOrderItems]);
  return (
    <>
      {loading ? (
        <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
      ) : (
        <Grid container className="box--shadow bg--white p1 mt1">
          {/* ----------------------General project Information--------------------- */}
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb1 mt0 fw500"
            >
              General Project Information
            </Text>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {/* ---------project name input------- */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Project Name*</span>
                </Text>
                <Input
                  color={state.projectNameErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  maxLength={25}
                  value={state.projectName}
                  type="text"
                  onChange={(e) => {
                    dispatchState({
                      type: "projectName",
                      payload: e.target.value,
                    });
                  }}
                />
                <Text
                  type={state.projectNameErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    state.projectNameErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Projectname.
                </Text>
              </Grid>

              {/* -------project city input----------- */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Project City*</span>
                </Text>
                <Input
                  color={state.projectCityErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  maxLength={25}
                  value={state.projectCity}
                  type="text"
                  onChange={(e) => {
                    dispatchState({
                      type: "projectCity",
                      payload: e.target.value,
                    });
                  }}
                />
                <Text
                  type={state.projectCityErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    state.projectCityErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Project City.
                </Text>
              </Grid>
              {/* -------main contractor name input----------- */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Main Contractor Name*</span>
                </Text>
                <Input
                  color={state.mainContractorNameErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  maxLength={30}
                  value={state.mainContractorName}
                  type="text"
                  onChange={(e) => {
                    dispatchState({
                      type: "mainContractorName",
                      payload: e.target.value,
                    });
                  }}
                />
                <Text
                  type={state.mainContractorNameErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    state.mainContractorNameErr
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  Please Enter Main Contractor Name.
                </Text>
              </Grid>
              {/* -------client name and project start date input----------- */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Client Name*</span>
                </Text>
                <Input
                  color={state.clientNameErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  maxLength={30}
                  value={state.clientName}
                  type="text"
                  onChange={(e) => {
                    dispatchState({
                      type: "clientName",
                      payload: e.target.value,
                    });
                  }}
                />
                <Text
                  type={state.clientNameErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    state.clientNameErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Client Name.
                </Text>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">Project Start Date*</span>
                </Text>
                <Input
                  color={state.projectStartDateErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={state.projectStartDate}
                  type="date"
                  onChange={(e) => {
                    dispatchState({
                      type: "projectStartDate",
                      payload: e.target.value,
                    });
                  }}
                />
                <Text
                  type={state.projectStartDateErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    state.projectStartDateErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Project Start Date.
                </Text>
              </Grid>
              {/* -------type of project and expected comp date input----------- */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt0"
                >
                  <span className="fw500">Type of Project*</span>
                </Text>
                <SelectBox
                  data={[...projectTypes].map(
                    (val: any) => val[0].toUpperCase() + val.slice(1)
                  )}
                  placeHolder="Select Project Type"
                  defaultVal={state?.typeOfProject}
                  onChange={(e) => {
                    let target = { ...e };
                    dispatchState({
                      type: "typeOfProject",
                      payload: target.target.value,
                    });
                  }}
                  resetVal={state?.typeOfProject === "" ? true : false}
                  changeReset={changeResetProjectType}
                  borderColor={state?.typeOfProjectErr ? "danger" : "primary"}
                />
                <Text
                  type={state.typeOfProjectErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    state.typeOfProjectErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Type Of Project.
                </Text>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">Expected Completion Date*</span>
                </Text>
                <Input
                  color={state.projectCompleteDateErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={state.projectCompleteDate}
                  type="date"
                  min={state.projectStartDate}
                  onChange={(e) => {
                    dispatchState({
                      type: "projectCompleteDate",
                      payload: e.target.value,
                    });
                  }}
                />
                <Text
                  type={state.projectCompleteDateErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    state.projectCompleteDateErr
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  Please Enter Project Completion Date (exp).
                </Text>
              </Grid>
              {/* -----------description--------- */}
              <Grid item xs={4} className="text_area">
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt0"
                >
                  <span className="fw500">Description</span>
                </Text>
                <TextArea
                  // label="Description"
                  name="description"
                  value={state.description}
                  maxLength={100}
                  onChange={(e) => {
                    dispatchState({
                      type: "description",
                      payload: e.target.value,
                    });
                  }}
                  placeholder="Write description here"
                />
              </Grid>
              {/* -------------------------work order Information--------------------- */}
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={18}
                  className="mb0 mt fw500"
                >
                  Work Order Information
                </Text>
              </Grid>
              {/* ----------work order issue date input------ */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Work Order Issue Date*</span>
                </Text>
                <Input
                  color={state.workOrderIssueDateErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={state.workOrderIssueDate}
                  type="date"
                  onChange={(e) => {
                    dispatchState({
                      type: "workOrderIssueDate",
                      payload: e.target.value,
                    });
                  }}
                />
                <Text
                  type={state.workOrderIssueDateErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    state.workOrderIssueDateErr
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  Please Enter Work Order Issue Date.
                </Text>
              </Grid>
              {/* ----------work order value input------ */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Total Work Order Value*</span>
                </Text>
                <Input
                  color={state.workOrderValueErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder=""
                  required
                  value={parseFloat(state.workOrderValue).toFixed(2)}
                  type="number"
                  className="read_only_input"
                  onChange={(e) => {
                    if (
                      Number(e?.target?.value) > 100000000 ||
                      Number(e?.target?.value) < 0
                    ) {
                      return false;
                    } else {
                      dispatchState({
                        type: "workOrderValue",
                        payload: e.target.value,
                      });
                    }
                  }}
                  disabled
                />
                <Text
                  type={state.workOrderValueErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    state.workOrderValueErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Work Order Value.
                </Text>
              </Grid>
              {/* ----------Total Pile Length input------ */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">
                    Total Pile Length to be Filled (m)*
                  </span>
                </Text>
                <Input
                  color={state.totalPileLengthErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder=""
                  required
                  value={parseFloat(state.totalPileLength).toFixed(2)}
                  type="number"
                  className="read_only_input"
                  onChange={(e) => {
                    if (
                      Number(e?.target?.value) > 1000000000 ||
                      Number(e?.target?.value) < 0
                    ) {
                      return false;
                    } else {
                      dispatchState({
                        type: "totalPileLength",
                        payload: e.target.value,
                      });
                    }
                  }}
                  disabled
                />
                <Text
                  type={state.totalPileLengthErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    state.totalPileLengthErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Pile Length.
                </Text>
              </Grid>
              {/* ----work order items details----- */}
              <Grid item xs={12}>
                <WorkOrderItems
                  triggered={triggered}
                  changeBackToFalse={changeBackToFalse}
                  setWorkOrderItems={setWorkOrderItems}
                  woCancel={woCancel}
                  setWoCancel={setWoCancel}
                />
              </Grid>
              {/* ----------work order pdf upload------ */}
              <Grid item xs={12} className="pdf_upload_button">
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb1 mt0"
                >
                  <span className="fw500">Upload Work Order Pdf*</span>
                </Text>
                <Grid className="d-flex v-center">
                  <Button
                    category={pdfErr ? "warning" : "primary"}
                    icon="delete"
                    onClick={() => {
                      pdfFileInputRef.current?.click();
                    }}
                    type="button"
                    isRounded={true}
                  >
                    Upload File
                  </Button>
                  <Grid
                    className={
                      pdfName !== ""
                        ? "file_name box--shadow ml-1 p d-flex"
                        : "d-none"
                    }
                  >
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb0 mt0"
                    >
                      <span className="fw400">
                        {pdfName && pdfName.slice(22)}
                      </span>
                    </Text>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={14}
                      className="mb0 mt0"
                      onTextClick={() => {
                        setPdfName("");
                      }}
                    >
                      <span
                        className="iconify"
                        data-icon="charm:circle-cross"
                      ></span>
                    </Text>
                  </Grid>
                </Grid>
                <Text
                  type={pdfErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={pdfErr ? "mb0 mt0 ml" : "d-none"}
                >
                  Please Upload File (Max size 5MB).
                </Text>

                <input
                  type="file"
                  accept="application/pdf"
                  className="d-none"
                  ref={pdfFileInputRef}
                  onChange={(e: any) => {
                    const file = e.target.files;
                    if (file && file[0]?.size < 5242881) {
                      let formData = new FormData();
                      formData.append("file", file[0]);
                      dispatch(
                        postPdf({ endPoint: "file/upload", data: formData })
                      ).then((val: any) => {
                        setPdfName(val?.payload?.data?.fileName);
                      });
                      setPdfErr(false);
                    } else {
                      setPdfName("");
                      setPdfErr(true);
                    }

                    e.target.value = null;
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------------Pile related Information table----------------------- */}
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={18}
                  className="mb1 mt2 fw500"
                >
                  Pile Related Information
                  <span
                    className={
                      checkboxCountErr ? "text--danger ml-1" : "d-none"
                    }
                  >
                    Please Select at least 4 Steps
                  </span>
                  <span
                    className={
                      dupStepNumberErr ? "text--danger ml-1" : "d-none"
                    }
                  >
                    Please Select the unique Step Number.
                  </span>
                </Text>
              </Grid>
              <Grid item xs={12} className="pileFilling_steps_table">
                <TableContainer>
                  <Table
                    className={tableClasses.table}
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell className="f16 fw500" align="left">
                          Choose Step
                        </TableCell>
                        <TableCell className="f16 fw500" align="left">
                          Step Number
                        </TableCell>
                        <TableCell className="f16 fw500" align="left">
                          Name of Step
                        </TableCell>
                        <TableCell className="f16 fw500" align="left">
                          Ideal Time (hrs)
                        </TableCell>
                        <TableCell className="f16 fw500" align="left">
                          Weightage of Step
                          <br />
                          Starting Point*
                        </TableCell>
                        <TableCell className="f16 fw500" align="left">
                          Weightage of Step
                          <br />
                          Completion Point*
                        </TableCell>
                        <TableCell className="f16 fw500 pl" align="left">
                          Is This Step Mandatory?*
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {stepsData &&
                        stepsData?.map((row: any, index: number) => (
                          <TableRow key={index}>
                            {/* -------checkbox---- */}
                            <TableCell
                              component="th"
                              scope="row"
                              className="f14 fw500"
                            >
                              <Checkbox
                                color="primary"
                                inputProps={{
                                  "aria-label": "uncontrolled-checkbox",
                                }}
                                name="checkbox"
                                checked={
                                  stepsValues[index]?.checkbox === true
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  handleStepChange(index, e);
                                }}
                              />
                            </TableCell>
                            {/* --------step Number---- */}
                            <TableCell className="f14 fw400" align="left">
                              <Grid className="step_number_selectBox">
                                <SelectBox
                                  data={stepNumbers}
                                  label="Select"
                                  placeHolder=""
                                  name="stepNumber"
                                  defaultVal={stepsValues[
                                    index
                                  ]?.stepNumber.toString()}
                                  value={stepsValues[
                                    index
                                  ]?.stepNumber.toString()}
                                  resetVal={
                                    stepsValues[index]?.stepNumber === ""
                                      ? true
                                      : false
                                  }
                                  changeReset={changeReset}
                                  onChange={(e) => {
                                    handleStepChange(index, e);
                                  }}
                                  borderColor={
                                    stepsValuesError[index]?.stepNumberErr
                                      ? "danger"
                                      : !stepsValues[index]?.checkbox
                                      ? "default"
                                      : "primary"
                                  }
                                  disabled={!stepsValues[index]?.checkbox}
                                />
                                <Text
                                  type={
                                    stepsValuesError[index]?.stepNumberErr
                                      ? "danger"
                                      : "normal"
                                  }
                                  fonts="normal"
                                  fontSize={12}
                                  className={
                                    stepsValuesError[index]?.stepNumberErr
                                      ? "mb0 mt0"
                                      : "d-none"
                                  }
                                >
                                  Please Select Step.
                                </Text>
                              </Grid>
                            </TableCell>
                            {/* ------Ideal Time---- */}
                            <TableCell
                              className={
                                stepsValues[index]?.checkbox
                                  ? "f14 fw400 capitalize"
                                  : "f14 fw400 capitalize text--disabled"
                              }
                              align="left"
                            >
                              {row}
                            </TableCell>
                            <TableCell className="f14 fw400" align="left">
                              <Grid className="idealTime_input">
                                <Input
                                  color={
                                    stepsValuesError[index]?.idealTimeErr
                                      ? "danger"
                                      : "primary"
                                  }
                                  fonts="normal"
                                  placeholder=""
                                  name="idealTime"
                                  value={stepsValues[index]?.idealTime}
                                  type="number"
                                  min={1}
                                  max={100}
                                  className={
                                    stepsValues[index]?.checkbox
                                      ? "primaryBorder"
                                      : ""
                                  }
                                  onChange={(e) => {
                                    // if((e.target.value.length<=3||e.target.value.length===6)&&!/^\d{0,3}(\.(25|50|75))?$/.test(e.target.value))
                                    if (
                                      !/^\d{0,3}(\.\d{0,2})?$/.test(
                                        e.target.value
                                      )
                                    )
                                      return false;
                                    else {
                                      handleStepChange(index, e);
                                    }
                                  }}
                                  disabled={!stepsValues[index]?.checkbox}
                                />
                                <Text
                                  type={
                                    stepsValuesError[index]?.idealTimeErr
                                      ? "danger"
                                      : "normal"
                                  }
                                  fonts="normal"
                                  fontSize={12}
                                  className={
                                    stepsValuesError[index]?.idealTimeErr
                                      ? "mb0 mt0 float-right"
                                      : "d-none"
                                  }
                                >
                                  Please Fill.
                                </Text>
                              </Grid>
                            </TableCell>
                            {/* -------weightage step start--- */}
                            <TableCell className="f14 fw400" align="left">
                              <Grid className="weightage_step_start">
                                <Input
                                  color={
                                    stepsValuesError[index]?.weightageStartErr
                                      ? "danger"
                                      : "primary"
                                  }
                                  fonts="normal"
                                  placeholder=""
                                  name="weightageStart"
                                  value={stepsValues[index]?.weightageStart}
                                  type="number"
                                  min={1}
                                  max={100}
                                  className={
                                    stepsValues[index]?.checkbox
                                      ? "primaryBorder"
                                      : ""
                                  }
                                  onChange={(e) => {
                                    if (parseInt(e.target.value) > 100)
                                      return false;
                                    if (!/^\d{0,3}$/.test(e.target.value))
                                      return false;
                                    if (+e.target.value / 10 > 0) {
                                      const remainder = +e.target.value / 10;
                                      console.log(
                                        +e.target.value >=
                                          100 - totalPoints - remainder + 1
                                      );

                                      if (
                                        +e.target.value >=
                                        100 - totalPoints + remainder
                                      ) {
                                        return false;
                                      } else {
                                        handleStepChange(index, e);
                                      }
                                    }
                                    if (
                                      +e.target.value >=
                                      100 - totalPoints + 1
                                    )
                                      return false;
                                    else {
                                      handleStepChange(index, e);
                                    }
                                  }}
                                  disabled={!stepsValues[index]?.checkbox}
                                />
                                <Text
                                  type={
                                    stepsValuesError[index]?.weightageStartErr
                                      ? "danger"
                                      : "normal"
                                  }
                                  fonts="normal"
                                  fontSize={12}
                                  className={
                                    stepsValuesError[index]?.weightageStartErr
                                      ? "mb0 mt0 float-right"
                                      : "d-none"
                                  }
                                >
                                  Please Fill Weightage Point.
                                </Text>
                              </Grid>
                            </TableCell>
                            {/* -----weightage step complete----- */}
                            <TableCell className="f14 fw400" align="left">
                              <Grid className="weightage_step_comp">
                                <Input
                                  color={
                                    stepsValuesError[index]
                                      ?.weightageCompleteErr
                                      ? "danger"
                                      : "primary"
                                  }
                                  fonts="normal"
                                  placeholder=""
                                  name="weightageComplete"
                                  value={parseFloat(
                                    stepsValues[index]?.weightageComplete
                                  )}
                                  type="number"
                                  min={1}
                                  max={100}
                                  className={
                                    stepsValues[index]?.checkbox
                                      ? "primaryBorder"
                                      : ""
                                  }
                                  onChange={(e) => {
                                    if (
                                      Number(e?.target?.value) > 100 ||
                                      Number(e?.target?.value) < 0
                                    ) {
                                      return false;
                                    }
                                    if (+e.target.value / 10 > 0) {
                                      const remainder = +e.target.value / 10;
                                      console.log(
                                        +e.target.value >=
                                          100 - totalPoints - remainder + 1
                                      );

                                      if (
                                        +e.target.value >=
                                        100 - totalPoints + remainder
                                      ) {
                                        return false;
                                      } else {
                                        handleStepChange(index, e);
                                      }
                                    }
                                    if (
                                      +e.target.value >=
                                      100 - totalPoints + 1
                                    ) {
                                      return false;
                                    } else {
                                      handleStepChange(index, e);
                                    }
                                  }}
                                  disabled={!stepsValues[index]?.checkbox}
                                />
                                <Text
                                  type={
                                    stepsValuesError[index]
                                      ?.weightageCompleteErr
                                      ? "danger"
                                      : "normal"
                                  }
                                  fonts="normal"
                                  fontSize={12}
                                  className={
                                    stepsValuesError[index]
                                      ?.weightageCompleteErr
                                      ? "mb0 mt0 float-right"
                                      : "d-none"
                                  }
                                >
                                  Please Fill Weightage Point.
                                </Text>
                              </Grid>
                            </TableCell>
                            {/* --------radio box----- */}
                            <TableCell
                              className="f14 fw400"
                              align="left"
                              style={{ minWidth: 220 }}
                            >
                              <Grid className="radio_box">
                                <Radio
                                  checked={
                                    stepsValues[index]?.isMandatory ===
                                      "mandatory" &&
                                    stepsValues[index]?.checkbox
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    handleStepChange(index, e);
                                  }}
                                  value="mandatory"
                                  name="isMandatory"
                                  inputProps={{ "aria-label": "Mandatory" }}
                                  color="primary"
                                  disabled={!stepsValues[index]?.checkbox}
                                />
                                <label>Mandatory</label>
                                <Radio
                                  checked={
                                    stepsValues[index]?.isMandatory !==
                                      "mandatory" &&
                                    stepsValues[index]?.checkbox
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    handleStepChange(index, e);
                                  }}
                                  value="optional"
                                  name="isMandatory"
                                  inputProps={{ "aria-label": "Optional" }}
                                  color="primary"
                                  disabled={!stepsValues[index]?.checkbox}
                                />
                                <label>Optional</label>
                              </Grid>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid className="ms1">
                <Text type={"normal"} fonts="normal">
                  Total Points Available
                </Text>

                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder=""
                  required
                  value={100 - totalPoints}
                  min={1}
                  max={100}
                  type="number"
                  className="read_only_input mt1"
                  onChange={(e) => {
                    if (
                      Number(e?.target?.value) > 1000000000 ||
                      Number(e?.target?.value) < 0
                    ) {
                      return false;
                    } else {
                      dispatchState({
                        type: "totalPileLength",
                        payload: e.target.value,
                      });
                    }
                  }}
                  disabled
                />
                <Text
                  type={totalPointsErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={totalPointsErr ? "mb0 mt0 float-right" : "d-none"}
                >
                  Total Points remaining should be 0
                </Text>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} container>
            <Grid className="mt1 ml-1">
              <Button
                type="button"
                size="medium"
                isRounded={true}
                category="primary"
                onClick={() => {
                  handleSubmit();
                }}
                className="submit_button"
              >
                {loadingBtn ? (
                  <Loader
                    color="#fff"
                    loading={loadingBtn}
                    size={8}
                    height="auto"
                  />
                ) : (
                  "Submit"
                )}
              </Button>
            </Grid>
            <Grid className={!editButton ? "d-none" : "mt1 ml-1"}>
              <Button
                type="button"
                size="medium"
                isRounded={true}
                category="border-only"
                onClick={() => {
                  handleCancel();
                }}
                className="submit_button"
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default CreateProject;
